export default __webpack_public_path__ + "static/media/bg-login.cb95a668.jpg";